<button mat-raised-button [matTooltipPosition]="position" [matTooltip]="message" (click)="eventClick()" [color]="notificationEvent.isOptedByUser ? 'primary' : ''">
    {{notificationEvent.eventName}}
</button>
